<template>
  <div class="MobileGeneral">
    <div class="mobile-header">
      <div class="header-content">
        <div class="header-title">
          <h2>Fornecedores</h2>
          <p>Gestão e cadastro de fornecedores</p>
        </div>
        <b-button class="BtnRegister" @click="openModalToReceive">
          <div class="btn-icon">
            <b-icon-building></b-icon-building>
          </div>
          <span>Novo Fornecedor</span>
        </b-button>
      </div>
    </div>

    <transition name="slide-fade">
      <div v-if="showFilters" class="mobile-filters-container">
        <div class="filter-row">
          <b-form-select
            v-model="type"
            :style="
              showFilterTypes && `border-left: none; border-radius: 0 0 0 0`
            "
            :options="filterCombobox"
            @change="handleShowFilterTypes"
            class="mobile-select"
          ></b-form-select>
        </div>

        <div class="filter-row search-row">
          <b-input
            v-model="textPesquisa"
            placeholder="Buscar fornecedor..."
            class="mobile-search-input"
            @keyup.enter="handleSearch"
          ></b-input>
          <b-button @click="handleSearch" class="btn-search-mobile">
            <b-icon-search></b-icon-search>
          </b-button>
        </div>
      </div>
    </transition>

    <div class="status-scroll-container">
      <div class="status-card suppliers-card">
        <div class="status-icon">
          <b-icon-building></b-icon-building>
        </div>
        <div class="status-info">
          <div class="status-count">{{ this.counter.providerCount }}</div>
          <div class="status-label">Fornecedores</div>
        </div>
      </div>
    </div>

        <div class="header-actions">
      <b-button class="btn-toggle-filters" @click="showFilters = !showFilters">
        <b-icon-funnel-fill></b-icon-funnel-fill>
      </b-button>
    </div>

    <div v-if="loadingList" class="list-loading-state">
      <b-spinner class="list-loading-spinner"></b-spinner>
      <span>Carregando fornecedores...</span>
    </div>

    <div v-else class="card-list-container">
      <div
        v-for="supplier in readSuppliers"
        :key="supplier.id"
        class="supplier-card"
        @click.stop="findById(supplier)"
      >
        <div class="card-header-mobile">
          <div class="supplier-id">
            <div class="supplier-avatar">
              <b-icon-building></b-icon-building>
            </div>
            <div class="id-info">
              <div class="supplier-code">{{ supplier.cpfCnpj || "000.000.00-00" }}</div>
            </div>
          </div>
          <div class="card-actions">
            <b-button
              variant="link"
              class="delete-btn"
              @click.stop="destroySupplier(supplier.id)"
            >
              <b-icon-trash></b-icon-trash>
            </b-button>
          </div>
        </div>

        <div class="card-body-mobile">
          <div class="supplier-info">
            <h4 class="supplier-name">{{ supplier.nomeFantasia || supplier.razaoSocial }}</h4>
            <div class="contact-info">
              <div class="contact-item">
                <b-icon-telephone class="contact-icon"></b-icon-telephone>
                <span class="contact-text">{{ supplier.celular || "(00) 0000-0000" }}</span>
                <img
                  v-if="supplier.celular"
                  class="whatsapp-btn"
                  :src="whatsapp"
                  @click="redirectWhatsApp(supplier.celular)"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <span :class="['supplier-status', supplier.status === 'inativo' ? 'inactive' : 'active']">
            {{ supplier.status === 'inativo' ? 'Inativo' : 'Ativo' }}
          </span>
        </div>
      </div>

      <div v-if="!readSuppliers.length" class="empty-state">
        <b-icon-building scale="3"></b-icon-building>
        <p>Nenhum fornecedor encontrado</p>
      </div>
    </div>

    <div v-if="readSuppliers.length" class="pagination-section">
      <b-button
        class="pagination-btn"
        :disabled="page === 1 || loadingList"
        @click="previousPage"
        size="lg"
        variant="outline-secondary"
      >
        <b-icon-chevron-left></b-icon-chevron-left>
        Anterior
      </b-button>

      <span class="pagination-page">{{ paginationLabel }}</span>
      <b-button
        class="pagination-btn"
        :disabled="this.dataLengthSupplier < 9 || loadingList"
        @click="nextPage"
        size="lg"
        variant="outline-secondary"
      >
        Próxima
        <b-icon-chevron-right></b-icon-chevron-right>
      </b-button>
    </div>

    <b-modal
      id="modal-excluir"
      hide-footer
      hide-header
      centered
      size="md"
      title="Excluir"
      no-close-on-backdrop
    >
      <div>
        <h6 class="textModalBill">Deseja excluir a compra?</h6>
        <div class="ctnLoadDelAll" v-if="spinDelete">
          <b-spinner class="spin"></b-spinner>
          <span>Aguarde ...</span>
        </div>
        <div v-else class="ctnDelAll">
          <button
            class="btnContentConfirmedWhiteDelAll"
            @click="$bvModal.hide('modal-excluir')"
          >
            Não, obrigado!
          </button>
          <button class="btnContentConfirmedDelAll" @click="deleteAll">
            Sim, quero excluir!
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import whatsapp from "../../../assets/whatsapp.svg";
import serviceRegisters from "../../../services/serviceRegisters";
import api from "../../../services/axios";

export default {
  props: {
    getAllCustomer: {
      type: Boolean,
    },
  },
  data() {
    return {
      counter: {},
      textPesquisa: "",
      type: "",
      startDate: "",
      endDate: "",
      readSuppliers: [],
      page: 1,
      whatsapp: whatsapp,
      filterCombobox: [
        { value: "nome", text: "Nome" },
        { value: "cpfCnpj", text: "CPF/CNPJ" },
        { value: "celular", text: "Contato" },
        { value: "status", text: "Status" },
        { value: "", text: "Todos" },
      ],
      filterTypes: [
        { value: "includes", text: "Contém" },
        { value: "start", text: "Inicia por" },
      ],
      filterType: "includes",
      showFilterTypes: false,
      showFilters: false,
      spinDelete: false,
      dataLengthSupplier: 0,
      spinGeneral: false,
      totalPages: 1,
      totalItems: 0,
      perPage: 9,
      loadingList: false,
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_SUPPLIER",
    ]),
    async deleteAll() {
      this.spinDelete = true;
      try {
        this.$bvModal.hide("modal-excluir");
        return this.$toast.open({
          message: "Deletado com sucesso!",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else
          this.$toast.open({
            message: `${error.response}`,
            type: "error",
          });
      } finally {
        this.spinDelete = false;
      }
    },
    async findById(supplier) {
      try {
        const result = await api.get(`/providers/${supplier.id}`);
        
        const supplierData = result.data.data || result.data;
        this.openModalToReceive(supplierData);
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED")) {
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        } else {
          this.$toast.open({
            message: "Ocorreu um erro ao buscar o fornecedor!",
            type: "error",
          });
        }
      }
    },

    // async findCustomerSales() {
    //   this.customerSales = await serviceSale.findCustomerSales(
    //     this.dataSearchCustomer.id,
    //     1
    //   );
    // },

    // async findCustomerBills() {
    //   this.customerBills = await serviceBill.findCustomerBills(
    //     this.dataSearchCustomer.id,
    //     1
    //   );
    // },

    async detailsSupplier(supplier) {
      try {
        const result = await api.get(`/providers/${supplier.id}`);
        this.openModalDetails(result.data);
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED")) {
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        } else {
          this.$toast.open({
            message: "Ocorreu um erro ao buscar o fornecedor!",
            type: "error",
          });
        }
      }
    },
    async readSupplier(page = 1) {
      try {
        this.loadingList = true;
        this.spinGeneral = true;

        const response = await api.get(
          `/providers?q=${encodeURIComponent(this.textPesquisa)}&type=${this.type}&page=${page}&filterType=${this.filterType}`,
        );

        const payload = response.data;
        const items = Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.data?.data)
          ? payload.data.data
          : [];

        const meta = payload?.meta || payload?.pagination || payload?.data?.meta || {};

        this.page = page;
        this.dataLengthSupplier = items.length;
        this.readSuppliers = items;

        const resolvedTotalItems = Number(
          meta.total || payload?.total || payload?.data?.total || 0,
        );
        const fallbackTotalItems = this.hasActiveFilters
          ? (page - 1) * this.perPage +
            (items.length >= this.perPage ? this.perPage + 1 : items.length)
          : Number(this.counter?.providerCount || 0);

        this.totalItems = resolvedTotalItems || fallbackTotalItems || items.length;

        const resolvedTotalPages = Number(
          meta.last_page ||
            meta.totalPages ||
            payload?.last_page ||
            payload?.totalPages ||
            payload?.data?.last_page ||
            0,
        );

        this.totalPages =
          resolvedTotalPages ||
          (this.totalItems ? Math.ceil(this.totalItems / this.perPage) : this.page);
      } catch (error) {
        return this.$toast.open({
          message: "Não foi possível listar os fornecedores",
          type: "warning",
        });
      } finally {
        this.loadingList = false;
        this.spinGeneral = false;
      }
    },
    handleSearch() {
      this.page = 1;
      this.readSupplier(1);
    },
    openModalToReceive(suppliers) {
      this.SET_DATA_SEARCH_FROM_SUPPLIER(suppliers);

      const name = "supplier";
      this.ALTER_TYPE_REGISTER(name);
      this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral");
      this.SET_COLAPSE_REGISTER(true);
      this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer");
    },

    openModalDetails(detailsSupplier) {
      this.SET_DATA_SEARCH_FROM_SUPPLIER(detailsSupplier);

      this.ALTER_TYPE_REGISTER("supplier");
      this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral");
      this.SET_COLAPSE_REGISTER(true);
      this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer");
    },

    async destroySupplier(supplierId) {
      try {
        await api.delete(`/providers/${supplierId}`);
        this.readSupplier(this.page);
        return this.$toast.open({
          message: "Fornecedor deletado com sucesso!",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else
          this.$toast.open({
            message: "Erro ao deletar fornecedor",
            type: "error",
          });
      }
    },

    clearSearch() {
      this.textPesquisa = "";
      this.type = "";
      this.startDate = "";
      this.endDate = "";
    },

    redirectWhatsApp(number) {
      if (number) {
        const formatedNumber = number.replace(/\D/g, "");
        const url = `https://wa.me/55${formatedNumber}`;
        window.open(url, "_blank");
      }
    },

    handleShowFilterTypes() {
      const types = ["nome", "cpfCnpj", "celular", "endereco", "cidade", "cep"];

      this.page = 1;

      if (types.includes(this.type)) {
        this.showFilterTypes = true;
        return;
      }

      this.showFilterTypes = false;
    },
    async countAll() {
      try {
        this.counter = await serviceRegisters.countAll();

        if (!this.hasActiveFilters) {
          this.totalItems = Number(this.counter?.providerCount || 0);
          this.totalPages = this.totalItems
            ? Math.ceil(this.totalItems / this.perPage)
            : 1;
        }
      } catch (error) {
        console.log(error.response);
      }
    },
    nextPage() {
      if (!this.canGoNext) return;
      this.readSupplier(this.page + 1);
    },
    previousPage() {
      if (this.page === 1) return;
      this.readSupplier(this.page - 1);
    },
  },
  computed: {
    ...mapState({
      isSearchRegisters: (state) => state.isSearchRegisters,
    }),
    hasActiveFilters() {
      return Boolean(this.textPesquisa || this.type || this.filterType !== "includes");
    },
    canGoNext() {
      if (this.totalPages > this.page) {
        return true;
      }

      return this.dataLengthSupplier >= this.perPage;
    },
    paginationLabel() {
      if (this.totalPages > this.page || this.totalPages > 1) {
        return `Página ${this.page} de ${this.totalPages}`;
      }

      return `Página ${this.page}`;
    },
  },
  watch: {
    async getAllCustomer() {
      this.page = 1;
      await this.readSupplier(1);
    },
    isSearchRegisters() {
      this.readSupplier(this.page);
    },
    filterType() {
      this.page = 1;
    },
  },
  created() {
    this.countAll();
    this.readSupplier(1);
  },
};
</script>
<style scoped>
.mobile-header {
  padding: 20px;
  width: 100%;
  background: linear-gradient(135deg, #006256 0%, #709e8a 100%);
  color: white;
  box-shadow: 0 8px 32px rgba(0, 98, 86, 0.3);
  position: relative;
  overflow: hidden;
}

.mobile-header::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
}

.header-title h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: white;
}

.header-title p {
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
}

.BtnRegister {
  background: linear-gradient(135deg, #ffffff, #f8f9fa);
  color: #006256;
  border: none;
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.BtnRegister:hover, .BtnRegister:focus {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  color: #006256;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.btn-icon {
  width: 24px;
  height: 24px;
  background: #006256;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.header-actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 5px 20px;
  background: rgba(0, 98, 86, 0.05);
}

.btn-toggle-filters {
  background: white;
  color: #006256;
  border: 1px solid rgba(0, 98, 86, 0.2);
  border-radius: 12px;
  width: 44px;
  height: 44px;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.btn-toggle-filters:hover {
  background: #006256;
  color: white;
  transform: scale(1.05);
}

.mobile-filters-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: white;
  padding: 20px;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
}

.filter-row {
  margin-bottom: 16px;
}

.search-row {
  display: flex;
  gap: 12px;
  margin-bottom: 0;
}

.mobile-search-input {
  flex: 1;
  border-radius: 12px;
  height: 44px;
  border: 2px solid #e9ecef;
  padding: 0 16px;
  font-size: 16px;
  transition: all 0.3s ease;
}

.mobile-search-input:focus {
  border-color: #006256;
  box-shadow: 0 0 0 3px rgba(0, 98, 86, 0.1);
}

.btn-search-mobile {
  background: linear-gradient(135deg, #006256, #709e8a);
  border: none;
  border-radius: 12px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 98, 86, 0.3);
  transition: all 0.3s ease;
}

.btn-search-mobile:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 98, 86, 0.4);
}

.status-scroll-container {
  display: flex;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, rgba(0, 98, 86, 0.03), rgba(112, 158, 138, 0.03));
}

.status-card {
  flex: 1;
  background: white;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(0, 98, 86, 0.1);
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.status-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.suppliers-card {
  border-left: 4px solid #3498db;
}

.status-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.suppliers-card .status-icon {
  background: linear-gradient(135deg, #3498db, #2980b9);
}

.status-info {
  display: flex;
  flex-direction: column;
}

.status-count {
  font-size: 18px;
  font-weight: 700;
  color: #006256;
  margin: 0;
}

.status-label {
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.card-list-container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.supplier-card {
  background: white;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.supplier-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #3498db, #2980b9);
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.supplier-card:active {
  transform: scale(0.98);
}

.supplier-card:hover::before {
  transform: scaleY(1);
}

.card-header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px 0 16px;
}

.supplier-id {
  display: flex;
  align-items: center;
  gap: 12px;
}

.supplier-avatar {
  font-size: 32px;
  color: #3498db;
}

.id-info {
  display: flex;
  flex-direction: column;
}

.supplier-code {
  font-weight: 700;
  color: #006256;
  font-size: 14px;
}

.supplier-ref {
  font-size: 12px;
  color: #6c757d;
  font-family: 'Monaco', 'Menlo', monospace;
}

.card-actions {
  display: flex;
  gap: 8px;
}

.delete-btn {
  color: #dc3545;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.delete-btn:hover {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.card-body-mobile {
  padding: 0 16px 16px 16px;
}

.supplier-info {
  padding-left: 44px;
}

.supplier-name {
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 12px 0;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.contact-icon {
  color: #3498db;
  font-size: 14px;
}

.contact-text {
  font-size: 16px;
  color: #4a5568;
  font-weight: 500;
  flex: 1;
}

.whatsapp-btn {
  width: 24px;
  height: 24px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.whatsapp-btn:hover {
  transform: scale(1.1);
}

.card-footer {
  padding: 8px 16px;
  background: rgba(0, 98, 86, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.supplier-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.supplier-status.active {
  background: rgba(34, 197, 94, 0.1);
  color: #22c55e;
}

.supplier-status.active::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #22c55e;
}

.supplier-status.inactive {
  background: rgba(220, 53, 69, 0.1);
  color: #c73535;
}

.supplier-status.inactive::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #c73535;
}

.empty-state {
  text-align: center;
  color: #a0aec0;
  padding: 60px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
}

.list-loading-state {
  text-align: center;
  color: #a0aec0;
  padding: 60px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.list-loading-spinner {
  color: #006256;
}

.pagination-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  gap: 12px;
}

.pagination-btn {
  flex: 1;
  min-width: 100px;
  padding: 12px 16px;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s;
}

.pagination-btn:disabled {
  opacity: 0.3;
}

.pagination-page {
  font-size: 1rem;
  font-weight: 700;
  color: #495057;
  white-space: nowrap;
  padding: 0 8px;
}

.slide-fade-enter-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.6, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.mobile-select {
  border: 2px solid #e9ecef;
  border-radius: 12px;
  height: 44px;
  font-size: 16px;
  padding: 0 16px;
  transition: all 0.3s ease;
}

.mobile-select:focus {
  border-color: #006256;
  box-shadow: 0 0 0 3px rgba(0, 98, 86, 0.1);
}

@media (max-width: 380px) {
  .header-content {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
  
  .status-scroll-container {
    flex-direction: column;
  }

  .pagination-section {
    padding: 16px 20px 24px;
  }
  
  .supplier-name {
    font-size: 16px;
  }
}

.textModalBill {
  text-align: center;
  color: #2d3748;
  margin-bottom: 20px;
}

.ctnLoadDelAll {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 20px;
}

.spin {
  color: #006256;
}

.ctnDelAll {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.btnContentConfirmedWhiteDelAll {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 10px 20px;
  color: #6c757d;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btnContentConfirmedWhiteDelAll:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.btnContentConfirmedDelAll {
  background: linear-gradient(135deg, #dc3545, #c82333);
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  color: white;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btnContentConfirmedDelAll:hover {
  background: linear-gradient(135deg, #c82333, #a02622);
  transform: translateY(-1px);
}
</style>
